import { IconButton, Tooltip } from "@mui/material";
import { DarkModeOutlined, LightModeOutlined } from "@mui/icons-material";
import { useUnifiedColorMode } from "shared/hooks/useUnifiedColorMode";

export default function ColorModeToggle() {
    const { mode, toggle } = useUnifiedColorMode();

    if (!mode) {
        return null; // Prevent render until mode is initialized
    }

    const isDark = mode === "dark";
    const nextMode = isDark ? "light" : "dark";

    return (
        <Tooltip title={`Switch to ${nextMode} mode`}>
            <IconButton
                onClick={toggle}
                data-screenshot="toggle-mode"
                sx={{
                    "&.MuiIconButton-root": { 
                        color:"gray",
                        backgroundColor: "transparent",
                        border:"none",
                    }, 
                }}
                size="small"
            >
                {isDark ? <LightModeOutlined /> : <DarkModeOutlined />}
            </IconButton>
        </Tooltip>
    );
}
